"use client";
import React, { useState } from "react";
import { FinishEnum, GameCard } from "modules/cards/model/card";
import { cn } from "utils/utils";
import { CardImageMarketIcons } from "modules/common/components/CardDetailsDialog/CardImageMarketIcons";
import { CardEssentialInfo } from "modules/common/components/CardDetailsDialog/CardEssentialInfo";
import { CardFaceInfo } from "modules/common/components/CardDetailsDialog/CardFaceInfo";
import { CardSetPrice } from "modules/common/components/CardDetailsDialog/CardSetPrice";
import { CardOwnershipRibbon } from "modules/common/components/CardDetailsDialog/CardOwnershipRibbon";
import { CardPreviewSizing } from "utils/styles";
import { SizingOptions } from "../CardPreviewLoading";
import { getCardPresentationAdapter } from "modules/common/gameRegistry";

export interface CardImageTextProps {
  card: GameCard;
  isDialog?: boolean;
  sizing?: SizingOptions;
  finish?: FinishEnum;
  isPriority?: boolean;
  /** Pairs the image with same-named card images across navigations. */
  viewTransitionName?: string;
}

export const CardImageText = ({
  card,
  isDialog = false,
  sizing = CardPreviewSizing,
  finish,
  isPriority = false,
  viewTransitionName,
}: CardImageTextProps) => {
  const [flipped, setFlipped] = useState(false);
  const adapter = getCardPresentationAdapter(card.game);
  const flippedFace = adapter.flippedFace(card, flipped);
  const inlineFaces = adapter.inlineFaces(card);

  return (
    <div
      className={cn(
        "mx-auto grid max-w-full grid-cols-1 gap-2 md:gap-4",
        isDialog
          ? "sm:grid-cols-2 lg:max-w-full"
          : "gap-1 md:grid-cols-2 md:gap-4"
      )}
    >
      <div
        className={cn(
          "flex items-center",
          isDialog
            ? "justify-center lg:justify-center"
            : "justify-center md:justify-end"
        )}
      >
        <CardImageMarketIcons
          card={card}
          flipped={flipped}
          setFlipped={setFlipped}
          sizing={sizing}
          finish={finish}
          isPriority={isPriority}
          viewTransitionName={viewTransitionName}
        />
      </div>

      <div className="flex flex-col">
        {flippedFace ? (
          <CardFaceInfo face={flippedFace} />
        ) : (
          <CardEssentialInfo card={card} />
        )}

        {inlineFaces?.map((face) => (
          <React.Fragment key={face.id}>
            <div className="my-1 border-t border-gray-300" />
            <CardFaceInfo face={face} />
          </React.Fragment>
        ))}

        <div className="my-2 border-t border-gray-300" />
        <CardSetPrice card={card} finish={finish} />
        <div className="mt-3">
          <CardOwnershipRibbon dataId={card.id} cardName={card.name} />
        </div>
      </div>
    </div>
  );
};
